module.exports = __webpack_public_path__ + "img/KinokoTable36.f5027017.jpg";